// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Product$Showside from "./Product.bs.js";
function fromTaggedProducts(taggedProducts, products) {
  return Belt_Array.mapWithIndex(Belt_Array.keepMap(Belt_Array.map(taggedProducts, function (taggedProduct) {
    return [taggedProduct, Product$Showside.getProductById(products, taggedProduct.productId)];
  }), function (param) {
    var b = param[1];
    if (b !== undefined) {
      return [param[0], b];
    }
  }), function (i, param) {
    return {
      id: String(i),
      x: 0,
      y: 0,
      variantId: param[0].variantId,
      product: param[1]
    };
  });
}
function fromDTO(pin, products) {
  var product = Product$Showside.getProductById(products, pin.productId);
  var visible = Belt_Option.getWithDefault(pin.visible, true);
  if (product !== undefined && visible) {
    return {
      id: pin.id,
      x: pin.x,
      y: pin.y,
      variantId: pin.variantId,
      product: product
    };
  }
}
export { fromTaggedProducts, fromDTO };
/* Product-Showside Not a pure module */